import React from 'react';
import {Grid} from 'semantic-ui-react';

export default (props) => {
    return (
        <Grid>
            <Grid.Row centered>
                {props.children}
            </Grid.Row>
        </Grid>    
    )
    
}


// WEBPACK FOOTER //
// ./src/components/questions/QuestionContainer.jsx